import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent, COOKIE_CATEGORIES } from '../context/CookieContext';
import { initMatomo, disableMatomo, trackPageView } from '../services/matomo';

export function MatomoTracker() {
  const location = useLocation();
  const { hasConsent, isLoaded } = useCookieConsent();
  const previousPath = useRef('');
  const matomoEnabled = useRef(false);

  // Initialize or disable Matomo based on consent
  useEffect(() => {
    if (!isLoaded) return;

    if (hasConsent(COOKIE_CATEGORIES.analytics)) {
      // User has given consent for analytics
      if (!matomoEnabled.current) {
        initMatomo();
        matomoEnabled.current = true;
        // Track current page after init
        trackPageView(document.title, window.location.href);
      }
    } else {
      // User has not given consent or revoked it
      if (matomoEnabled.current) {
        disableMatomo();
        matomoEnabled.current = false;
      }
    }
  }, [hasConsent, isLoaded]);

  // Track page views on route change
  useEffect(() => {
    if (!isLoaded || !matomoEnabled.current) return;
    if (!hasConsent(COOKIE_CATEGORIES.analytics)) return;

    const currentPath = location.pathname + location.search;
    
    // Only track if path actually changed
    if (previousPath.current !== currentPath) {
      // Small delay to ensure page title is updated
      setTimeout(() => {
        trackPageView(document.title, window.location.href);
      }, 100);
      previousPath.current = currentPath;
    }
  }, [location, hasConsent, isLoaded]);

  return null;
}
